(() => {
  'use strict';
  const dialog = document.querySelector('[data-welcome-dialog]');
  const teaser = document.querySelector('[data-welcome-teaser]');
  if (!dialog || !teaser || typeof dialog.showModal !== 'function') return;
  const cooldownKey = 'cat-welcome-until-v2';
  const legacyKey = 'cat-welcome-seen-v1';
  const pendingKey = 'cat-welcome-submit-v1';
  const visitsKey = 'cat-welcome-pages-v2';
  const cooldown = 30 * 24 * 60 * 60 * 1000;
  const success = dialog.querySelector('[data-welcome-success]');
  const errors = dialog.querySelector('[data-welcome-errors]');
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); return true; } catch { return false; } };
  const remove = (storage, key) => { try { window[storage].removeItem(key); } catch {} };
  const remember = () => write('localStorage', cooldownKey, String(Date.now() + cooldown));
  let stopped = false;
  let timer;
  const stop = () => { stopped = true; clearTimeout(timer); teaser.hidden = true; };
  const dismiss = () => { remember(); stop(); };
  const open = () => {
    if (!window.SobremesaDialogs?.open(dialog.id, document.querySelector('.site-header a'))) return false;
    remember(); stop(); return true;
  };
  teaser.querySelector('[data-welcome-open]').addEventListener('click', open);
  teaser.querySelector('[data-welcome-dismiss]').addEventListener('click', dismiss);
  dialog.querySelector('form')?.addEventListener('submit', () => write('sessionStorage', pendingKey, String(Date.now())));
  dialog.addEventListener('close', () => { remove('sessionStorage', pendingKey); dismiss(); });

  // Only an actual newsletter submission may reopen the form automatically.
  const pending = Number(read('sessionStorage', pendingKey));
  if (pending && Date.now() - pending < 30 * 60 * 1000 && (success || errors)) {
    remove('sessionStorage', pendingKey);
    open(); return;
  }
  if (pending) remove('sessionStorage', pendingKey);
  if (dialog.dataset.welcomeSubscriber === 'true' || window.Shopify?.designMode) return;
  if (!['index', 'collection'].includes(teaser.dataset.pageType) || Number(teaser.dataset.cartCount) > 0) return;
  const until = Number(read('localStorage', cooldownKey));
  if (until > Date.now()) return;
  // Honor visitors who already closed the old popup, without showing it again.
  if (!until && read('localStorage', legacyKey)) { remember(); return; }
  // If persistence is unavailable, stay quiet instead of repeating on every page.
  if (!write('localStorage', cooldownKey, String(until || 0))) return;
  const visits = Number(read('sessionStorage', visitsKey)) + 1;
  write('sessionStorage', visitsKey, String(visits));
  let activeTime = 0;
  let previous = Date.now();
  let lastInteraction = previous;
  let browsed = visits >= 2 || window.scrollY >= window.innerHeight;
  let shown = false;
  const started = previous;
  const busy = () => document.visibilityState !== 'visible' ||
    document.querySelector('dialog[open],details.mega-trigger[open]') ||
    document.activeElement?.matches('input,textarea,select,[contenteditable=true]');
  const hasCart = () => [...document.querySelectorAll('.bag-link [data-cart-count]')].some(el => Number(el.textContent) > 0);
  const interacted = () => {
    lastInteraction = Date.now();
    if (window.scrollY >= window.innerHeight) browsed = true;
  };
  ['scroll', 'pointerdown', 'keydown'].forEach(name => window.addEventListener(name, interacted, { passive: true }));
  const tick = () => {
    if (stopped) return;
    const now = Date.now();
    if (!shown && Number(read('localStorage', cooldownKey)) > now) { stop(); return; }
    if (hasCart()) { dismiss(); return; }
    if (document.visibilityState === 'visible') activeTime += Math.min(now - previous, 1000);
    previous = now;
    if (shown) {
      if (busy()) { stop(); return; }
    } else if (activeTime >= 30000 && browsed && now - lastInteraction >= 8000 && !busy()) {
      if (!remember()) { stop(); return; }
      teaser.hidden = false;
      shown = true;
    }
    if (!shown && now - started > 5 * 60 * 1000) { stop(); return; }
    timer = setTimeout(tick, 1000);
  };
  document.addEventListener('visibilitychange', () => { previous = Date.now(); if (shown && document.visibilityState !== 'visible') stop(); });
  window.addEventListener('pagehide', stop, { once: true });
  timer = setTimeout(tick, 1000);
})();
